(() => {
  'use strict';

  const DESKTOP_MQ = window.matchMedia('(min-width: 768px)');
  const ROOT_SELECTOR = '.section-new-product-aug26 .new-product-aug26';
  const GALLERY_SELECTOR = '.gallery--layout-editorial';

  function getActiveSlides(gallery) {
    return Array.from(
      gallery.querySelectorAll('.product-slideshow:not(.slick-slider) .slide')
    ).filter((slide) => !slide.classList.contains('slide--inactive-option'));
  }

  function resetGallery(gallery) {
    gallery.querySelectorAll('.slide.new-pdp-media-collapsed').forEach((slide) => {
      slide.classList.remove('new-pdp-media-collapsed');
    });

    gallery.querySelectorAll('.slide.new-pdp-view-more-slide').forEach((slide) => {
      slide.classList.remove('new-pdp-view-more-slide');
      slide.querySelectorAll('[data-new-pdp-view-more-runtime]').forEach((node) => node.remove());
    });
  }

  function awakenGateMedia(slide) {
    // Match Broadcast's lazy-loading convention: anything still marked manual
    // must be promoted to `lazyload` before we constrain the slide.
    slide.querySelectorAll('.lazyload--manual').forEach((node) => {
      node.classList.remove('lazyload--manual');
      node.classList.add('lazyload');
    });

    // Ask lazysizes to unveil the real sixth image immediately.
    if (window.lazySizes?.loader?.unveil) {
      slide.querySelectorAll('.lazyload').forEach((node) => {
        try {
          window.lazySizes.loader.unveil(node);
        } catch (_) {}
      });
    }
  }

  function buildViewMore(gallery) {
    resetGallery(gallery);

    if (!DESKTOP_MQ.matches) return;
    if (gallery.dataset.newPdpGalleryMode !== 'editorial') return;

    const slideshow = gallery.querySelector('.product-slideshow:not(.slick-slider)');
    if (!slideshow) return;

    const visibleLimit = Math.max(
      1,
      parseInt(gallery.dataset.newPdpVisibleMedia || '5', 10) || 5
    );

    const activeSlides = getActiveSlides(gallery);
    if (activeSlides.length <= visibleLimit) return;

    const gateSlide = activeSlides[visibleLimit];
    const gateLink = gateSlide?.querySelector('a.show-gallery');
    if (!gateSlide || !gateLink) return;

    // Force actual sixth-image media to load before applying the gate.
    awakenGateMedia(gateSlide);

    // Images 7+ remain in DOM for Broadcast lightbox, but disappear from page flow.
    activeSlides.slice(visibleLimit + 1).forEach((slide) => {
      slide.classList.add('new-pdp-media-collapsed');
    });

    gateSlide.classList.add('new-pdp-view-more-slide');

    const remainingCount = activeSlides.length - visibleLimit;
    const overlay = document.createElement('button');
    overlay.type = 'button';
    overlay.className = 'new-pdp-view-more-overlay';
    overlay.setAttribute('data-new-pdp-view-more-runtime', '');
    overlay.setAttribute(
      'aria-label',
      `Open full image gallery. ${remainingCount} more image${remainingCount === 1 ? '' : 's'}.`
    );

    const inner = document.createElement('span');
    inner.className = 'new-pdp-view-more-overlay__inner';

    const count = document.createElement('span');
    count.className = 'new-pdp-view-more-overlay__count';
    count.textContent = `+ ${remainingCount} MORE IMAGE${remainingCount === 1 ? '' : 'S'}`;

    const cta = document.createElement('span');
    cta.className = 'new-pdp-view-more-overlay__cta';
    cta.textContent = 'Open Image Gallery';

    inner.append(count, cta);
    overlay.append(inner);
    gateSlide.append(overlay);

    overlay.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      gateLink.dispatchEvent(
        new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        })
      );
    });
  }

  function refreshAll(scope = document) {
    scope.querySelectorAll?.(`${ROOT_SELECTOR} ${GALLERY_SELECTOR}`).forEach(buildViewMore);
  }

  function init() {
    // Initial pass after Broadcast + collab parser have had time to settle.
    window.setTimeout(() => refreshAll(), 120);

    if (window.jQuery) {
      window.jQuery(window)
        .off('cc-variant-updated.newProductAug26')
        .on('cc-variant-updated.newProductAug26', () => {
          window.setTimeout(() => refreshAll(), 100);
        });
    }

    const onMediaChange = () => window.setTimeout(() => refreshAll(), 80);

    try {
      DESKTOP_MQ.addEventListener('change', onMediaChange);
    } catch (_) {
      DESKTOP_MQ.addListener(onMediaChange);
    }

    document.addEventListener('shopify:section:load', (event) => {
      window.setTimeout(() => refreshAll(event.target), 120);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();


(() => {
  'use strict';

  const MQ = window.matchMedia('(min-width: 768px)');
  const SECTION_SELECTOR = '.section-new-product-aug26';
  const CONTENT_SELECTOR = '[data-new-pdp-sticky-content]';
  const TOP_GAP = 16;
  const BOTTOM_GAP = 16;

  const states = new WeakMap();

  let lastScrollY = window.scrollY;
  let ticking = false;
  let resizeTimer = 0;

  function stickyHeaderHeight() {
    const value = getComputedStyle(document.documentElement)
      .getPropertyValue('--theme-sticky-header-height');
    return parseFloat(value) || 0;
  }

  function boundsFor(content) {
    const headerTop = stickyHeaderHeight() + TOP_GAP;
    const contentHeight = content.offsetHeight;
    const availableHeight =
      window.innerHeight - headerTop - BOTTOM_GAP;

    /*
      For tall content, bottomTop is the viewport Y-coordinate at which
      the content's bottom sits exactly BOTTOM_GAP above the viewport bottom.
    */
    const bottomTop =
      window.innerHeight - BOTTOM_GAP - contentHeight;

    return {
      headerTop,
      bottomTop,
      contentHeight,
      fits: contentHeight <= availableHeight
    };
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function getState(section, content, bounds) {
    let state = states.get(section);

    if (!state) {
      const currentTop = content.getBoundingClientRect().top;

      state = {
        activeTop: bounds.fits
          ? bounds.headerTop
          : clamp(currentTop, bounds.bottomTop, bounds.headerTop)
      };

      states.set(section, state);
    }

    return state;
  }

  function apply(section, scrollDelta) {
    const content = section.querySelector(CONTENT_SELECTOR);
    if (!content) return;

    if (!MQ.matches) {
      content.style.removeProperty('--new-pdp-native-sticky-top');
      content.style.removeProperty('--new-pdp-active-sticky-top');
      states.delete(section);
      return;
    }

    const bounds = boundsFor(content);
    const state = getState(section, content, bounds);

    /*
      Preserve the measured v0.10 bottom anchor as a useful inspector
      fingerprint and fallback.
    */
    const measuredTop = bounds.fits
      ? bounds.headerTop
      : bounds.bottomTop;

    content.style.setProperty(
      '--new-pdp-native-sticky-top',
      `${Math.round(measuredTop)}px`
    );

    if (bounds.fits) {
      state.activeTop = bounds.headerTop;
    } else if (scrollDelta !== 0) {
      /*
        Core V. Chapman product-detail travel:
        - scroll down  -> active top moves upward 1:1 until bottom boundary
        - scroll up    -> active top moves downward 1:1 until header boundary

        Native position: sticky performs the actual pinning and parent-boundary
        release. We only move the sticky constraint between the two viewport
        boundaries.
      */
      state.activeTop = clamp(
        state.activeTop - scrollDelta,
        bounds.bottomTop,
        bounds.headerTop
      );
    } else {
      state.activeTop = clamp(
        state.activeTop,
        bounds.bottomTop,
        bounds.headerTop
      );
    }

    content.style.setProperty(
      '--new-pdp-active-sticky-top',
      `${Math.round(state.activeTop)}px`
    );
  }

  function updateAll() {
    ticking = false;

    const currentScrollY = window.scrollY;
    const scrollDelta = currentScrollY - lastScrollY;
    lastScrollY = currentScrollY;

    document.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
      apply(section, scrollDelta);
    });
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(updateAll);
  }

  function resetGeometry() {
    /*
      On resize / accordion height change, seed from the element's real current
      viewport position so recalculation does not create a visible jump.
    */
    document.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
      const content = section.querySelector(CONTENT_SELECTOR);
      if (!content || !MQ.matches) {
        states.delete(section);
        return;
      }

      const bounds = boundsFor(content);
      const currentTop = content.getBoundingClientRect().top;

      states.set(section, {
        activeTop: bounds.fits
          ? bounds.headerTop
          : clamp(currentTop, bounds.bottomTop, bounds.headerTop)
      });
    });

    lastScrollY = window.scrollY;
    requestUpdate();
  }

  function scheduleReset() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(resetGeometry, 40);
  }

  function init() {
    resetGeometry();

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', scheduleReset);

    try {
      MQ.addEventListener('change', scheduleReset);
    } catch (_) {
      MQ.addListener(scheduleReset);
    }

    document.addEventListener('shopify:section:load', () => {
      window.setTimeout(resetGeometry, 80);
    });

    /*
      Accordions and Complete the Look can change the right-column height.
      Re-seed from the visible position after those geometry changes.
    */
    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(scheduleReset);

      document.querySelectorAll(
        `${SECTION_SELECTOR} ${CONTENT_SELECTOR}`
      ).forEach((content) => {
        observer.observe(content);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
